import React from 'react';

import { DropdownButton, Dropdown,  } from 'react-bootstrap';
import MuiAlert from '@material-ui/lab/Alert';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import WarningIcon from '@material-ui/icons/Warning';
import MenuIcon from '@material-ui/icons/Menu';

import api from '../../services/api';
import history from '../../history';


const Companies = ({ data }) => {
  const hasError = (data.success === 1);
  const response = hasError ? `Tem backups que precisam de atenção` :
    'Todos os backups foram conferidos e estão ok';
  let results = hasError ? 'error' : 'success';


  function refreshPage(info) {
    window.location.reload(info)
  }

  function handlePushMain() {
    localStorage.setItem('idEmpresa', data._id)
    localStorage.setItem('name_empresa', data.name)
    history.push('/reportsemanal')
  }

  async function handleClean() {
    await api.post('/clean/errors', {
      id: data._id,
    })
    refreshPage()
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
  }


  return (
    <tbody>
      <tr>
        <td>{data.name}</td>
        <td>
          <Alert severity={results} style={{ width: '100%' }}>
            {response}
          </Alert>
        </td>
        <td>
          <DropdownButton
            title={<MenuIcon />}
            id="bg-vertical-dropdown-1"
            variant="warning"
            size="md"
          >
            <Dropdown.Item onClick={handleClean}>
              Limpar alertas <WarningIcon />
            </Dropdown.Item>
            <Dropdown.Item onClick={handlePushMain}>
              Aceessar empresa <ArrowForwardIcon />
            </Dropdown.Item>
          </DropdownButton>
        </td>
      </tr>
    </tbody>
  )
}
export default Companies;
